<template>
    <q-card flat bordered class="q-mb-md">
        <q-card-section>
            <form method="post" :action="postUrl">
                <input type="hidden" name="_token" :value="csrfToken" />
                <input
                    type="hidden"
                    name="calendarId"
                    :value="selectedCalendarId"
                />
                <input
                    v-for="cId in selectedCampaigns"
                    :key="cId"
                    type="hidden"
                    name="campaignIds[]"
                    :value="cId"
                />

                <div class="row q-col-gutter-md">
                    <!-- Calendar Selection -->
                    <div class="col-12">
                        <q-select
                            v-model="selectedCalendarId"
                            outlined
                            dense
                            emit-value
                            map-options
                            :options="calendars"
                            :label="calendarLabel"
                            @update:model-value="onCalendarChange"
                        />
                    </div>

                    <!-- Campaigns Checkboxes -->
                    <div class="col-12">
                        <div class="text-subtitle2 q-mb-xs">
                            {{ areaLabel }}
                        </div>

                        <div
                            class="column q-gutter-xs bg-grey-1 q-pa-sm rounded-borders border"
                        >
                            <!-- Select All ("all") -->
                            <q-checkbox
                                v-model="allChecked"
                                :label="allLabel"
                                dense
                                class="q-py-xs"
                            />

                            <q-separator class="q-my-xs" />

                            <!-- Flexible Calendar -->
                            <q-checkbox
                                v-model="selectedCampaigns"
                                val="-1"
                                :label="flexibleCalendarLabel"
                                dense
                                class="q-py-xs"
                            />

                            <!-- Campaign Checkboxes -->
                            <q-checkbox
                                v-for="campaign in campaigns"
                                :key="campaign.id"
                                v-model="selectedCampaigns"
                                :val="String(campaign.id)"
                                :label="campaign.title"
                                dense
                                class="q-py-xs"
                            />
                        </div>
                    </div>

                    <!-- Time Range (Months) -->
                    <div class="col-12">
                        <q-select
                            v-model="selectedMonths"
                            outlined
                            dense
                            name="months"
                            emit-value
                            map-options
                            :options="monthsOptions"
                            :label="timeRangeLabel"
                        />
                    </div>

                    <!-- Submit Button -->
                    <div class="col-12 text-right">
                        <q-btn
                            type="submit"
                            color="primary"
                            icon="search"
                            :label="submitLabel"
                            :disable="selectedCampaigns.length === 0"
                            class="full-width"
                        />
                    </div>
                </div>
            </form>
        </q-card-section>
    </q-card>
</template>

<script>
import { ref, computed, watch } from "vue";

export default {
    name: "StatisticsFilterForm",
    props: {
        postUrl: {
            type: String,
            required: true,
        },
        csrfToken: {
            type: String,
            required: true,
        },
        basePath: {
            type: String,
            required: true,
        },
        calendars: {
            type: Array,
            default: () => [],
        },
        initialCalendarId: {
            type: String,
            default: "-1",
        },
        campaigns: {
            type: Array,
            default: () => [],
        },
        initialSelectedCampaigns: {
            type: Array,
            default: () => [],
        },
        monthsOptions: {
            type: Array,
            default: () => [],
        },
        initialSelectedMonths: {
            type: [String, Number],
            default: "",
        },
        calendarLabel: {
            type: String,
            default: "Calendar",
        },
        areaLabel: {
            type: String,
            default: "Select Area",
        },
        timeRangeLabel: {
            type: String,
            default: "Time Range",
        },
        submitLabel: {
            type: String,
            default: "Show Data",
        },
        flexibleCalendarLabel: {
            type: String,
            default: "Flexible Calendar",
        },
        allLabel: {
            type: String,
            default: "all",
        },
    },
    setup(props) {
        const selectedCalendarId = ref(props.initialCalendarId);
        const selectedMonths = ref(props.initialSelectedMonths);
        const selectedCampaigns = ref([...props.initialSelectedCampaigns]);

        const allOptions = computed(() => {
            return ["-1", ...props.campaigns.map((c) => String(c.id))];
        });

        const allChecked = computed({
            get() {
                return (
                    selectedCampaigns.value.length === allOptions.value.length
                );
            },
            set(val) {
                if (val) {
                    selectedCampaigns.value = [...allOptions.value];
                } else {
                    selectedCampaigns.value = [];
                }
            },
        });

        const onCalendarChange = (val) => {
            const targetId = val && val !== "-1" ? `/${val}` : "";
            window.location.href = `${props.basePath}${targetId}`;
        };

        return {
            selectedCalendarId,
            selectedMonths,
            selectedCampaigns,
            allChecked,
            onCalendarChange,
        };
    },
};
</script>

<style scoped>
.border {
    border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
